module.exports = __webpack_public_path__ + "static/media/confetti.89391d5f.svg";